import { defineStore } from 'pinia'
import { LOGIN_TOKEN } from '@/global/constants'
import { localCache } from '@/utils/cache'
import { ElMessage } from 'element-plus'
import router from '@/router'
import { accountLoginRequest, getUserInfo } from '@/service/modules/login'

const useLoginStore = defineStore('login', {
  state: () => ({
    token: '',
    userInfo: {}
  }),
  actions: {
    async loginAccountAction(account) {
      // 1.账号登录, 获取token等信息
      const loginResult = await accountLoginRequest(account)
      if (loginResult.Code === 200) {
        this.token = loginResult.Data.Token
        localCache.setCache(LOGIN_TOKEN, this.token)
      } else {
        ElMessage.error('请求失败,' + loginResult.Message)
        return true
      }
      // 2.获取登录用户的详细信息(role信息)
      const userInfoResult = await getUserInfo()
      if (userInfoResult.Code === 200) {
        const userInfo = userInfoResult.Data
        this.userInfo = userInfo
        localCache.setCache('userInfo', userInfo)
      } else if (userInfoResult.Code) {
        ElMessage.error('请求失败,' + userInfoResult.Message)
        return
      }
      router.push('/user')
    },
    loginAccountReset() {
      this.token = ''
      this.userInfo = null
    }
  }
})

export default useLoginStore
